import { styled as r, excludeProps as n, css as t } from "@lokalise/styled";
import { value as o, typography as d, spacing as e } from "../../utils/theme/index.js";
import { withInputErrorModifier as c } from "../../utils/styles/inputStyle.js";
const u = r.div`
	position: relative;
	width: 100%;
	display: grid;
	gap: 4px;
`, i = r.div`
	background-color: ${o("color.background.surface.middle")};
	color: ${o("color.text.input.placeholder")};
	width: 36px;
	border-left: 1px solid ${o("color.border.input.default")};
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	right: 0;
	height: 100%;
	top: 0;
	transition:
		border-color ${o("motion.speed.1")},
		background-color ${o("motion.speed.1")},
		color ${o("motion.speed.1")};
`, $ = r.button.attrs({
  type: "button"
}).withConfig({ shouldForwardProp: n(["opened", "error"]) })`
	${d("body.small.default")};
	border: 1px solid ${o("color.border.input.default")};
	height: ${o("size.height.input.default")};
	width: fit-content;
	color: ${o("color.text.default")};
	padding: ${e(1, 3)};
	padding-right: ${e(8)};
	border-radius: ${o("radius.input")};
	overflow: hidden;
	background-color: ${o("color.background.input.default")};
	position: relative;
	align-items: center;
	text-align: left;
	transition: border-color ${o("motion.speed.1")};
	cursor: pointer;
	&:focus-visible {
		outline: none; // use hover styles
	}

	// condition to avoid hover overriding style when opened
	${({ opened: l }) => l ? t`
					border-color: ${o("color.border.active")};
					color: ${o("color.text.default")};

					${i} {
						border-color: ${o("color.border.active")};
						color: ${o("color.text.default")};
					}
				` : t`
					&:hover {
						border-color: ${o("color.border.input.hover")};

						${i} {
							border-color: ${o("color.border.input.hover")};
						}
					}
				`}

	${c}
`, b = r.div`
	margin: ${e(4)};
`, h = r.span`
	${d("body.small.default")}
	color: ${o("color.text.input.placeholder")};
`, g = r.span`
	padding-right: ${e(2)};
	white-space: nowrap;
`;
export {
  u as Container,
  $ as DateBox,
  g as DateBoxLabel,
  b as DrawerContent,
  i as IconWrapper,
  h as Placeholder
};
//# sourceMappingURL=styles.js.map
